<div class="campaign-stats-container">
    <div class="stat-card" *ngFor="let stat of campaignStats; trackBy: trackByIndex">
    <div class="card-content">
      <div class="text-section">
        <div class="title">{{ stat.title }}</div>
        <div class="value" [style.color]="stat.color">{{ stat.value }}</div>
      </div>
      <div class="icon-section">
      
          <img [src]="stat.backgroundImage" alt="Campaign Stats Icon" class="stat-icon">
        
      </div>
    </div>
  </div>
</div>
